<template>
    <div id="asset-localisation-widget-component">
        <widget-wrapper-component :title="$t('asset_localisation_widget_component.location')" id-widget="asset-localisation-widget">
            <template v-slot:options>
                <MenuActionsComponent
                    :actions="[
                        {
                            title: $t('global_equipment.edit_site'),
                            icon: 'mdi-pencil',
                            emit: 'openEditSiteDialog',
                            has_access: userHasAccess('BASE', role_edit),
                        },
                    ]"
                    v-on:openEditSiteDialog="openEditSiteDialog"
                />
            </template>
            <template v-slot:default>
                <template v-if="asset.domicile">
                    <div class="mb-4">
                        <p class="text-uppercase font-color-medium font-14 font-weight-bold mb-2">
                            {{ $t('asset_localisation_widget_component.address') }}
                        </p>

                        <div class="d-flex gap-1 mb-2 font-12">
                            <v-icon>mdi-map-marker-outline</v-icon>
                            {{ displayToHumanDomicileAddress(asset.domicile) }}
                        </div>

                        <div class="d-flex gap-1 mb-2">
                            <v-icon>mdi-home</v-icon>
                            {{ asset.domicile.address_name }}
                        </div>
                    </div>

                    <div
                        v-if="
                            asset.domicile.contact_first_name ||
                            asset.domicile.contact_last_name ||
                            asset.domicile.contact_mail ||
                            asset.domicile.contact_phone ||
                            asset.domicile.contact_note
                        "
                    >
                        <p class="text-uppercase font-color-medium font-weight-bold mb-2">
                            {{ $t('asset_localisation_widget_component.on_site_contact') }}
                        </p>

                        <div class="text-12 d-flex flex-column gap-2 mb-2">
                            <div v-if="asset.domicile.contact_first_name || asset.domicile.contact_last_name" class="flex gap-1">
                                <v-icon class="text-skin-medium">mdi-account</v-icon>
                                <span class="text-skin-default">
                                    {{ asset.domicile.contact_first_name }} {{ asset.domicile.contact_last_name }}
                                </span>
                            </div>

                            <div v-if="asset.domicile.contact_mail" class="d-flex gap-1 mb-2">
                                <v-icon class="text-skin-medium">mdi-at</v-icon>
                                <span class="text-skin-default">{{ asset.domicile.contact_mail }}</span>
                            </div>

                            <div v-if="asset.domicile.contact_phone" class="d-flex gap-1 mb-2">
                                <v-icon class="text-skin-medium">mdi-phone</v-icon>
                                <span class="text-skin-default">{{ asset.domicile.contact_phone }}</span>
                            </div>

                            <div v-if="asset.domicile.contact_note" class="d-flex gap-1 mb-2">
                                <v-icon class="text-skin-medium">mdi-pencil</v-icon>
                                <span class="text-skin-default">{{ asset.domicile.contact_note }}</span>
                            </div>
                        </div>
                    </div>

                    <div ref="mapContainer" class="google-map-container"></div>
                </template>

                <template v-else>
                    {{ $t('asset_localisation_widget_component.no_domicile_associated') }}
                </template>
            </template>
        </widget-wrapper-component>
        <EditSiteDialogComponent ref="editSiteDialog" @updated:site="refreshSite" />
    </div>
</template>

<script>
import displayHuman from '@/mixin/displayHuman'
import maplibre from '@/mixin/maplibre'
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import EditSiteDialogComponent from '@/components/equipment/generic/form/EditSiteDialogComponent.vue'
import MenuActionsComponent from '@/components/global/containment/MenuActionsComponent.vue'

export default {
    name: 'AssetLocalisationWidgetComponent',
    components: { MenuActionsComponent, WidgetWrapperComponent, EditSiteDialogComponent },
    mixins: [displayHuman, maplibre],
    props: {
        asset: {
            type: Object,
            required: true,
        },
        asset_module: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        if (this.asset.domicile) this.renderMap()
    },
    methods: {
        renderMap() {
            this.$nextTick(() => {
                this.initMapLibre(this.$refs.mapContainer, { center: this.mapCenter, zoom: 16 })
                this.setSingleMarker({ ...this.mapCenter, iconUrl: this.asset_module.map_marker, size: 45 })
            })
        },
        openEditSiteDialog() {
            this.$refs.editSiteDialog.openEditSiteDialog(this.asset.domicile)
        },
        refreshSite(domicile) {
            this.asset.domicile = { ...domicile }
            this.panMapTo(this.mapCenter)
            this.setSingleMarker({ ...this.mapCenter, iconUrl: this.asset_module.map_marker, size: 45 })
        },
    },
    computed: {
        mapCenter() {
            return {
                lat: parseFloat(this.asset.domicile.latitude),
                lng: parseFloat(this.asset.domicile.longitude),
            }
        },
    },
}
</script>
